/**
 * Onboarding Steps Configuration
 * Defines the structure and flow of the onboarding process
 * Matches the structure returned by getStaticHierarchy API exactly
 */

import { IOnboardStaticHierarchyResponse } from '../services/zeos-api/contracts/Onboarding';

export const OnboardStepsConfig: IOnboardStaticHierarchyResponse = {
  steps: [
    {
      onboardStepId: 1,
      displayValue: "Account",
      sortOrder: 1,
      subSteps: [
        {
          onboardSubstepId: 1,
          onboardStepId: 1,
          pageSlug: "account-setup",
          substepName: "Account",
          substepNumber: 1,
          isBackButtonVisible: false,
          isForm: false,
        },
        {
          onboardSubstepId: 2,
          onboardStepId: 1,
          pageSlug: "account-verification",
          substepName: "Verify Email",
          substepNumber: 2,
          isBackButtonVisible: false,
          isForm: false,
        },
        {
          onboardSubstepId: 3,
          onboardStepId: 1,
          pageSlug: "account-password",
          substepName: "Create Password",
          substepNumber: 3,
          isBackButtonVisible: false,
          isForm: false,
        },
      ],
    },
    {
      onboardStepId: 2,
      displayValue: "Company",
      sortOrder: 2,
      subSteps: [
        {
          onboardSubstepId: 4,
          onboardStepId: 2,
          pageSlug: "company",
          substepName: "Company",
          substepNumber: 1,
          isBackButtonVisible: false,
          isForm: false,
        },
      ],
    },
    {
      onboardStepId: 3,
      displayValue: "Property",
      sortOrder: 3,
      subSteps: [
        {
          onboardSubstepId: 5,
          onboardStepId: 3,
          pageSlug: "property",
          substepName: "Property",
          substepNumber: 1,
          isBackButtonVisible: true,
          isForm: false,
        },
      ],
    },
    {
      onboardStepId: 4,
      displayValue: "Surveys",
      sortOrder: 4,
      subSteps: [
        {
          onboardSubstepId: 6,
          onboardStepId: 4,
          pageSlug: "surveys",
          substepName: "Optional Property Surveys",
          substepNumber: 1,
          isBackButtonVisible: true,
          isForm: false,
        },
        // FE-only nav helper so /onboarding/survey/:domain keeps Back → hub.
        // Not a separate DB onboard step (hub owns step 4).
        {
          onboardSubstepId: 12,
          onboardStepId: 4,
          pageSlug: "survey",
          substepName: "Property Survey",
          substepNumber: 2,
          isBackButtonVisible: true,
          isForm: false,
        },
      ],
    },
    {
      onboardStepId: 5,
      displayValue: "Utility Connection",
      sortOrder: 5,
      subSteps: [
        {
          onboardSubstepId: 7,
          onboardStepId: 5,
          pageSlug: "uapi",
          substepName: "Utility Connection",
          substepNumber: 1,
          isBackButtonVisible: true,
          isForm: false,
        },
        {
          onboardSubstepId: 8,
          onboardStepId: 5,
          pageSlug: "uapi-manual",
          substepName: "Utility Entry Manual",
          substepNumber: 2,
          isBackButtonVisible: true,
          isForm: false,
        },
        // {
        //   onboardSubstepId: 9,
        //   onboardStepId: 5,
        //   pageSlug: "uapi-confirm",
        //   substepName: "Utility Confirmation",
        //   substepNumber: 3,
        //   isBackButtonVisible: true,
        //   isForm: false,
        // },
      ],
    },
    {
      onboardStepId: 6,
      displayValue: "Summary",
      sortOrder: 6,
      subSteps: [
        {
          onboardSubstepId: 10,
          onboardStepId: 6,
          pageSlug: "summary",
          substepName: "Summary",
          substepNumber: 1,
          isBackButtonVisible: true,
          isForm: false,
        },
      ],
    },
  ],
};
